import { Account } from 'models/Account';
import { Person } from 'models/Person';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { editCustomerVat, getCustomerPersons } from 'storeAccount/actions/Customers';
import { RootStateAccount } from "storeAccount/accountStore";
import CustomerPersonRow from './CustomerPersonRow';


interface Props {
    customer: Account;
    person: Person;
    setPerson: (p: Person) => void;
}

interface Actions {
    getCustomerPersons: typeof getCustomerPersons
}

const AccountPersonManagementCard: React.FC<Props & Actions> = ({ person, customer, setPerson }) => {
    const [customerState] = useState(customer)

    return <CustomerPersonRow setPerson={setPerson} customer={customerState} person={person} />;
};

const mapStateToProps = (state: RootStateAccount) => {
    return {
        persons: state.Persons
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ editCustomerVat, getCustomerPersons }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountPersonManagementCard);
